import React from "react";
import { CloseIcon } from "../../assets";
import { formatFileSize, getFileExtention } from "../../utils/helpers";
import { imageExtensions } from "../../constants/const";

const ImagePreview = ({ file, onRemove, progress = 0, onNewChatScreen }) => {
  if (onNewChatScreen) {
    return (
      <div className="relative w-[46px] h-[46px] flex-shrink-0 bg-no-repeat border border-edge-border border-opacity-50 rounded-[10px] opacity-100 overflow-hidden">
        <img
          src={URL.createObjectURL(file)}
          alt={file.name}
          className="w-[46px] h-[46px] object-cover"
        />

        <div className="bg-[linear-gradient(223deg,_#ffffffff_5%,_#fffffffa_25%,#FFFFFF00_60%,#FFFFFF00_100%)] dark:bg-[linear-gradient(223deg,_#222222_0%,_#222222CC_20%,_#22222200_100%)] w-full h-full absolute top-0 right-0 pointer-events-none"></div>
        <button
          onClick={() => onRemove(file)}
          className="text-ink-ink-alternate transition-colors flex-shrink-0 absolute top-[4px] right-[2px] shadow-sm"
          aria-label={`Remove ${file.name}`}
        >
          <div className="relative z-10">
            <CloseIcon className="fill-ink-ink-alternate dark:fill-ink-white" />
          </div>
        </button>
      </div>
    );
  }
  return (
    <div className="relative w-[46px] h-[46px] flex-shrink-0 bg-no-repeat border border-edge-border border-opacity-50 rounded-[10px] opacity-100 overflow-hidden">
      {file?.downloadURL ? (
        <img
          src={file.downloadURL}
          alt={file.name}
          className="w-[46px] h-[46px] object-cover"
        />
      ) : null}

      {(!file?.downloadURL || file?.progress || progress) > 0 &&
        (file?.progress || progress) < 100 && (
          <div className="absolute inset-0 flex items-center justify-center">
            <svg className="w-6 h-6 transform -rotate-90" viewBox="0 0 36 36">
              <circle
                className="text-ink-gray-300"
                stroke="currentColor"
                strokeWidth="3"
                fill="transparent"
                r="16"
                cx="18"
                cy="18"
              />
              <circle
                className="text-ink-editor-warning"
                stroke="currentColor"
                strokeWidth="3"
                fill="transparent"
                strokeLinecap="round"
                strokeDasharray="100"
                strokeDashoffset={100 - (file?.progress || progress || 0)}
                r="16"
                cx="18"
                cy="18"
              />
            </svg>
          </div>
        )}
      <div className="bg-[linear-gradient(223deg,_#ffffffff_5%,_#fffffffa_25%,#FFFFFF00_60%,#FFFFFF00_100%)] dark:bg-[linear-gradient(223deg,_#222222_0%,_#222222CC_20%,_#22222200_100%)] w-full h-full absolute top-0 right-0 pointer-events-none"></div>
      <button
        onClick={() => onRemove(file)}
        className="text-ink-ink-alternate transition-colors flex-shrink-0 absolute top-[4px] right-[2px] shadow-sm"
        aria-label={`Remove ${file.name}`}
      >
        <div className="relative z-10">
          <CloseIcon className="fill-ink-ink-alternate dark:fill-ink-white" />
        </div>
      </button>
    </div>
  );
};

const FileUploadItem = ({ file, onRemove, progress = 0, onNewChatScreen }) => {
  const file_extension = getFileExtention(file?.name);
  const isImage = imageExtensions.includes((file_extension || "").toLowerCase());

  if (isImage) {
    return (
      <ImagePreview
        file={file}
        onRemove={onRemove}
        progress={progress}
        onNewChatScreen={onNewChatScreen}
      />
    );
  }
  return (
    <div className="relative overflow-hidden p-[7px] flex items-center bg-fill-navigation-hover border-edge-border dark:bg-fill-hex-363636 dark:border-edge-muted-control rounded-[10px] shadow-[0_0_0_0.5px_#D4D6D7] flex-shrink-0 max-w-[185px]">
      <div className="flex items-center gap-2">
        <div className="min-w-[32px] h-[32px] px-1 truncate overflow-hidden text-[10px] text-ink-on-primary bg-fill-primary rounded-md font-bold flex items-center justify-center">
          {file_extension}
        </div>
        <div className="max-w-28 truncate overflow-hidden">
          <h4 className="font-semibold text-xs truncate">{file?.name}</h4>
          <p className="text-[10px] text-ink-control-border">
            {formatFileSize(file?.size)}
          </p>
        </div>
      </div>

      <div className="p-1">
        <button
          onClick={() => onRemove(file)}
          className="text-ink-ink-alternate transition-colors flex-shrink-0"
          aria-label={`Remove ${file.name}`}
        >
          <CloseIcon className="fill-ink-ink-alternate dark:fill-ink-white" />
        </button>
      </div>
      {(file?.progress || progress) > 0 &&
        (file?.progress || progress) < 100 && (
          <div
            className="absolute bottom-0 left-0 right-0 h-[1px] bg-fill-editor-warning origin-left transition-transform duration-300 ease-in-out"
            style={{
              transform: `scaleX(${(file?.progress || progress || 0) / 100})`,
            }}
          />
        )}
    </div>
  );
};

export default FileUploadItem;
